import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/public-shortlist/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useDisablePublicCandidateListMutation = () => {
  return useMutation({
    mutationFn: async (jobId: string) => {
      const { data } = await fetchClient.DELETE(endpoints.publicCandidateList, {
        params: { path: { id: jobId } },
      });

      return data;
    },
    onSettled: (_data, _error, jobId) => {
      invalidateQuery(jobsQueryKeys.lists())();
      invalidateQuery(jobsQueryKeys.detail(jobId))();
    },
  });
};
